<mat-card>
  <mat-card-header>
    <mat-card-title>Gestión de Categoría de Incidencias</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isSearching && item != null">

      <ng-container *ngIf="canEdit">

        <form [formGroup]="formGroup">

          <div fxLayout="row stretch" fxLayout.xs="column">
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Código*</mat-label>
                <input matInput formControlName="Codigo" (keyup.enter)="onGuardar()" maxlength="100">
                <mat-error *ngIf="!formGroup.controls['Codigo'].valid && formGroup.controls['Codigo'].touched">
                  {{ getErrorCodigo() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nombre*</mat-label>
                <input matInput formControlName="Nombre" (keyup.enter)="onGuardar()" maxlength="200">
                <mat-error *ngIf="!formGroup.controls['Nombre'].valid && formGroup.controls['Nombre'].touched">
                  {{ getErrorNombre() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 98%">
                <mat-label *ngIf="!isCategoriaSearching">Categoria Padre</mat-label>
                <mat-label *ngIf="isCategoriaSearching">Cargando...</mat-label>
                <input  type="text" (keyup)="filterCategoriaList($event.target.value)"
                        placeholder="Nombre - Codigo" 
                        aria-label="Categoria Padre" 
                        formControlName="CategoriaPadreId"
                        matInput 
                        [matAutocomplete]="categoriaPadre">
                <mat-autocomplete autoActiveFirstOption
                                  [displayWith]="displayCategoria"
                                  #categoriaPadre="matAutocomplete">
                  <mat-option *ngFor="let categoria of filteredCategoriaList" [value]="categoria">
                    {{categoria.Nombre}} | {{categoria.Codigo}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
        </form>

        <div fxLayout="row stretch" fxLayout.xs="column">
          <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
            <mat-checkbox [(ngModel)]="item.Activo" (keyup.enter)="onGuardar()" color="primary">Activo</mat-checkbox> 
          </div><div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
            <mat-checkbox [(ngModel)]="item.MostrarEnDashBoard" (keyup.enter)="onGuardar()" color="primary">Mostrarse en dashboard de incidencias</mat-checkbox> 
          </div><div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
            <mat-checkbox [(ngModel)]="item.CodigoRequerido" (keyup.enter)="onGuardar()" color="primary">Campo código requerido?</mat-checkbox> 
          </div>
        </div>

        <div style="margin-top: 10px;" fxLayout="row stretch" fxLayout.xs="column">
          <button mat-raised-button (click)="onNuevoCampo()" *ngIf="canEdit" [disabled]="isProcessing()" color="primary" class="zb-button">Nuevo Campo</button>
        </div>
        <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching && incidenciaUsuarioCategoriaCustomList?.length > 0">
          <ejs-grid #grid [dataSource]='incidenciaUsuarioCategoriaCustomList' 
            [allowPaging]="true" 
            [pageSettings]='pageSettings'
            [allowSorting]="true" 
            [toolbar]='toolbarOptions' 
            [selectionSettings]='selectionOptions'
            [allowResizing]='true' (actionFailure)="onGridActionFailure($event)">
            <e-columns>
              <e-column width="70%" field='NombreCampo' headerText='Nombre Campo'></e-column>
              <e-column width="10%" textAlign='center' field='Requerido' headerText='Requerido'></e-column>
              <e-column width="10%" textAlign='center' field='Activo' headerText='Activo'></e-column>
              <e-column width="10%" textAlign='center' headerText='Borrar'></e-column>
            </e-columns>
            <ng-template #rowTemplate let-data>
              <tr class="e-row">
                <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                  <input type="text" [(ngModel)]="data.NombreCampo" name="NombreCampo"
                    (change)="onNuevoCampoChange(data.index, data.Id, $event)"
                    style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                </td>
                <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                  <input type="checkbox" [(ngModel)]="data.Requerido" name="Requerido"
                    (change)="onNuevoCampoChange(data.index, data.Id, $event)"
                    style="padding: 4px 2px; width: 90%; border: none; text-align: center;">
                </td>
                <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                  <input type="checkbox" [(ngModel)]="data.Activo" name="Activo"
                    (change)="onNuevoCampoChange(data.index, data.Id, $event)"
                    style="padding: 4px 2px; width: 90%; border: none; text-align: center;">
                </td>
                <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                  <a (click)="onNuevoCampoDelete(data.index)" style="cursor: pointer; background-color: transparent; padding: 4px 2px; width: 90%; border: none; text-align: center;">
                    <i class="fa fa-trash"></i></a>
                </td>
              </tr>
            </ng-template>
          </ejs-grid>
        </div>

      </ng-container>

      <ng-container *ngIf="!canEdit">

        <div fxLayout="row stretch" class="zb-readonly">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Código</b>: {{item.Codigo}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Nombre</b>: {{item.Nombre}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label><b>Activo</b>: {{item.Activo ? 'Sí' : 'No'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

        </div>

      </ng-container>

    </div>

  </mat-card-content>

  <mat-card-actions style="margin-bottom: 20px;">
    <div fxLayout="row stretch" fxLayout.xs="column">
      <button mat-raised-button (click)="onGuardar()" *ngIf="canEdit" [disabled]="isProcessing()" color="primary" class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
      <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">{{canEdit ? 'Cancelar' : 'Cerrar'}}</button>
      <button mat-raised-button (click)="onDelete()" *ngIf="canDelete && item != null && item.Id > 0" [disabled]="isSaving" color="warn" class="zb-button">
        {{ 'Eliminar'  }}
      </button>      
    </div>
  </mat-card-actions>

</mat-card>